import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions } from '../../actions/subscriptionActions';
import './SubscriptionConfig.scss';
import Area from './Identifiers/locationArea';
import Brand from './Identifiers/locationBrand';
import Continent from './Identifiers/locationContinent';
import ManagementCompany from './Identifiers/locationMgmtCompany';
import Region from './Identifiers/locationRegion';
import Type from './Identifiers/locationType';
import JobTitle from './Identifiers/taskBaselineJobTitle';
import Community from './Identifiers/taskCommunity';
import Department from './Identifiers/taskDepartment';
import Discipline from './Identifiers/taskDiscipline';
import Status from './Identifiers/taskStatus';
import Phase from './Identifiers/taskPhase';
import ProjectManager from './Identifiers/locationProjectManager';
import SubscriptionConfigNav from './SubscriptionConfigNav';
import Drawer from '../Common/Drawer/Drawer';

class SubscriptionConfigPage extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            activeIdentifierName: null,
            activeSectionName: null,
            drawerOpen: false,
            editId: null
        };
    }

    componentDidMount() {
        document.title = 'Admin';
    }

    changeIdentifier = (title, newIdentifierName) => {
        this.setState({ activeIdentifierName: newIdentifierName, activeSectionName: title });
    }

    closeActiveContainer = () => {
        this.setState({ activeIdentifierName: null });
    }

    closeDrawer = () => {
        this.setState({ drawerOpen: false, editId: null });
    }

    renderDrawer = () => {
        // only show the drawer if we have an active identifier and they clicked edit or add
        if (this.state.activeIdentifierName && this.state.drawerOpen) {
            // are we editing or adding new?
            let title = this.state.activeIdentifierName;
            if (this.state.editId) {
                title = "Edit " + title;
            } else {
                title = "New " + title;
            }
            return <Drawer title={title} isOpen={true} isWide={false} onSaveClick={this.closeDrawer} onCancelClick={this.closeDrawer}><p>Another switch/case to load the correct form goes here</p></Drawer>
        }

    }

    renderIdentifier = () => {

        switch (this.state.activeIdentifierName) {
            case "Area":
                return <Area subscriptionId={this.props.subscriptionId} onClose={this.closeActiveContainer} />
            case "Brand":
                return <Brand subscriptionId={this.props.subscriptionId} onClose={this.closeActiveContainer} />
            case "Continent":
                return <Continent subscriptionId={this.props.subscriptionId} onClose={this.closeActiveContainer} />
            case "Management_Company":
                return <ManagementCompany subscriptionId={this.props.subscriptionId} onClose={this.closeActiveContainer} />
            case "Project_Manager":
                return <ProjectManager subscriptionId={this.props.subscriptionId} onClose={this.closeActiveContainer} />
            case "Region":
                return <Region subscriptionId={this.props.subscriptionId} onClose={this.closeActiveContainer} />
            case "Type":
                return <Type subscriptionId={this.props.subscriptionId} onClose={this.closeActiveContainer} />
            case "Baseline_Job_Titles":
                return <JobTitle subscriptionId={this.props.subscriptionId} onClose={this.closeActiveContainer} />
            case "Community":
                return <Community subscriptionId={this.props.subscriptionId} onClose={this.closeActiveContainer} />
            case "Department":
                return <Department subscriptionId={this.props.subscriptionId} onClose={this.closeActiveContainer} />
            case "Discipline":
                return <Discipline subscriptionId={this.props.subscriptionId} onClose={this.closeActiveContainer} />
            case "Status":
                return <Status subscriptionId={this.props.subscriptionId} onClose={this.closeActiveContainer} />
            case "Phase":
                return <Phase subscriptionId={this.props.subscriptionId} onClose={this.closeActiveContainer} />
            default:
                return "";
        }

    }

    render() {
        // on mobile we only show either the list or the container
        const isListActive = (this.state.activeIdentifierName) ? '' : ' active';
        const isContainerActive = (!this.state.activeIdentifierName) ? '' : ' active';

        return (
            <div className="admin-settings-page">
                <div className={'identifier-list' + isListActive}>
                    <SubscriptionConfigNav onClick={this.changeIdentifier} activeItemName={this.state.activeIdentifierName} />
                </div>
                <div className={'identifier-container' + isContainerActive}>
                    {this.renderIdentifier()}
                </div>
                {this.renderDrawer()}
            </div>

        );
    }

}
SubscriptionConfigPage.propTypes = {
    subscriptionId: PropTypes.number.isRequired,
    actions: PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps) {
    let subscriptionId = 0;
    if (ownProps.match.params.subscriptionId) {
        subscriptionId = parseInt(ownProps.match.params.subscriptionId, 10)
    }

    return {
        subscriptionId: subscriptionId,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionConfigPage);

